import { BaseFilter } from './base-filter.interface';

export interface FiltroCommesse extends BaseFilter {
  matricola?: string | null;
  risorsa?: string | null;
  codiceCommessa?: string | null;
  descrizioneCommessa?: string | null;
}

export const filtroCommesseVuoto: FiltroCommesse = {
  matricola: null,
  risorsa: null,
  codiceCommessa: null,
  descrizioneCommessa: null,
  pageNumber: 1,
  pageSize: 10,
  orderBy: '',
  flagAsc: true,
  flagExport: false,
};
